<template>
  <div
    v-if="showEnvironmentSwitcher"
    class="environmentSwitcher"
  >
    <p>
      <strong>Current Environment: </strong>
      {{ currentEnvironment }}
    </p>
    <p />
    <p
      class="close-x"
      @click="toggleVisiblity"
    >
      x
    </p>
    <div>
      Switch Environments
      <select
        class="environment-select"
        @change="setThisEnvironmentCookie"
      >
        <option value="">
          Select environment
        </option>
        <option value="uat">
          UAT1
        </option>
        <option value="uat2">
          UAT2
        </option>
        <option value="uat3">
          UAT3
        </option>
        <option value="uat4">
          UAT4
        </option>
        <option value="prd_live">
          ProdLive
        </option>
        <option value="prd_preview">
          ProdPreview
        </option>
      </select>
    </div>
  </div>
  <div
    v-else
    class="environmentSwitcher"
  >
    <p
      class="open-plus"
      @click="toggleVisiblity"
    >
      +
    </p>
  </div>
</template>

<script>
import { setEnvironmentCookie } from '../../shared/utils/cookieHelper';
import { mapGetters } from 'vuex';
export default {
	name: 'EnvironmentSwitcher',
	props: ['currentEnvironment'],
	computed: {
		...mapGetters([
			'showEnvironmentSwitcher'
		])
	},
	methods: {
		setThisEnvironmentCookie(event) {
			setEnvironmentCookie(event);
		},
		toggleVisiblity() {
			this.$store.commit('updateShowEnvironmentSwitcher', !this.showEnvironmentSwitcher);
		}
	}
};
</script>

<style scoped>
	.environmentSwitcher {
		position: fixed;
		top: 81px;
		left: 0;
		border: 2px solid black;
		z-index: 100;
		background-color: white;
		padding: 2px 4px;
	}
	.environment-select {
		padding: 3px;
	}
	.close-x {
		cursor: pointer;
		position: absolute;
		right: 10px;
		top: 0;
	}
	.open-plus {
		cursor: pointer;
		margin: 3px;
	}
	.close-x:hover,
	.open-plus:hover {
		color: #009adf;
	}
</style>
